import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showUpdate, remove, update, setPaginaAtual } from './usuarioActions';
import { showNotificaoes } from './notificacoesUsuarioActions';
import SPButton from '../common/form/spButton';
import swal from 'sweetalert2';
import PermissaoUsuario from '../auth/permissao';

import ReactTableGT2A from '../common/grid/gridReactTable';
import PremiumTableShell from '../common/grid/premiumTableShell';

class UsuarioList extends Component {
  decodeToken = token => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join(''),
      );
      return JSON.parse(jsonPayload);
    } catch (e) {
      return null;
    }
  };

  isSelf = rowUser => {
    const { user } = this.props;
    if (!user || !user.token || !rowUser) return false;
    const decoded = this.decodeToken(user.token);
    const uid = decoded && String(decoded.id);
    return uid && String(rowUser.id) === uid;
  };

  removerUsuario(data) {
    swal({
      title: 'Deseja realmente excluir?',
      type: 'question',
      showCancelButton: true,
      confirmButtonColor: 'primary',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      allowOutsideClick: 'false',
    }).then(result => {
      if (result.value) {
        this.props.remove(data);
      }
    });
  }

  handlePageChange = page => {
    this.props.setPaginaAtual(page);
  };

  render() {
    const usuario = this.props.list || [];
    const paginaAtual = this.props.paginaAtual;

    const columns = [
      {
        Header: 'Ações',
        Cell: row => {
          const self = this.isSelf(row.original);
          return (
            <div>
              {self ? (
                <>
                  <SPButton
                    type="button"
                    className="warning btn-sm"
                    icon="pencil-alt"
                    data-title="Alterar"
                    onClick={() => this.props.showUpdate(row.original)}
                  />
                  <SPButton type="button" className="danger btn-sm" icon="trash-alt" disabled="disabled" />
                  <SPButton
                    type="button"
                    className="info btn-sm"
                    icon="bell"
                    data-title="Editar Notificações"
                    onClick={() => this.props.showNotificaoes(row.original)}
                  />
                </>
              ) : (
                <>
                  <PermissaoUsuario tela="CadUsuario" condicao={true}>
                    <SPButton
                      type="button"
                      className="warning btn-sm"
                      icon="pencil-alt"
                      data-title="Alterar"
                      onClick={() => this.props.showUpdate(row.original)}
                    />
                    <SPButton
                      type="button"
                      className="danger btn-sm"
                      icon="trash-alt"
                      data-title="Excluir"
                      onClick={() => this.removerUsuario(row.original)}
                    />
                    <SPButton
                      type="button"
                      className="info btn-sm"
                      icon="bell"
                      data-title="Editar Notificações"
                      onClick={() => this.props.showNotificaoes(row.original)}
                    />
                  </PermissaoUsuario>
                  <PermissaoUsuario tela="CadUsuario" condicao={false}>
                    <SPButton type="button" className="warning btn-sm" icon="pencil-alt" disabled="disabled" />
                    <SPButton type="button" className="danger btn-sm" icon="trash-alt" disabled="disabled" />
                    <SPButton type="button" className="info btn-sm" icon="bell" disabled="disabled" />
                  </PermissaoUsuario>
                </>
              )}
            </div>
          );
        },
        className: 'column_icon',
        width: 120,
        filterable: true,
        resizable: true,
        Filter: () => (
          <div className="rt-th">
            <span>Filtrar</span>
          </div>
        ),
      },
      {
        Header: 'Código',
        accessor: 'id',
        minWidth: 60,
        maxWidth: 80,
        filterable: true,
        resizable: true,
        className: 'column_grid column_center',
      },
      {
        Header: 'Nome',
        accessor: 'nome',
        minWidth: 150,
        className: 'column_grid',
        filterable: true,
        resizable: true,
        filterAll: true,
      },
      {
        Header: 'Usuário',
        accessor: 'usuario',
        minWidth: 150,
        className: 'column_grid',
        filterable: true,
        filterAll: true,
      },
      {
        Header: 'Grupo',
        accessor: 'grupo_descricao',
        className: 'column_grid',
        filterable: true,
        resizable: true,
        minWidth: 120,
        maxWidth: 200,
        filterAll: true,
      },
      {
        Header: 'Ativo',
        accessor: 'ativo',
        minWidth: 70,
        maxWidth: 100,
        filterable: true,
        resizable: true,
        className: 'column_grid column_center',
        Cell: ({ value }) => (parseInt(value) === 1 ? 'Sim' : 'Não'),
        filterMethod: (filter, row) => {
          if (!row[filter.id]) return false;
          const valorAtivo = parseInt(row[filter.id], 10);

          switch (filter.value) {
            case 'Sim':
              return valorAtivo === 1;
            case 'Não':
              return valorAtivo === 0;
            default:
              return true;
          }
        },
        Filter: ({ filter, onChange }) => (
          <select
            onChange={event => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : 'Todos'}
            name="ativo"
          >
            <option value="Todos">Todos</option>
            <option value="Sim">Sim</option>
            <option value="Não">Não</option>
          </select>
        ),
      },
    ];

    return (
      <div className="table-container" style={{ marginTop: '20px', width: '100%' }}>
        <style>{`
                    .usuario-premium-table .ReactTable .rt-th.column_center,
                    .usuario-premium-table .ReactTable .rt-td.column_center {
                        justify-content: center;
                        text-align: center;
                    }

                    .usuario-premium-table .ReactTable .rt-th.column_grid:not(.column_center),
                    .usuario-premium-table .ReactTable .rt-td.column_grid:not(.column_center) {
                        justify-content: flex-start;
                        text-align: left;
                    }

                    .usuario-premium-table .ReactTable .rt-th .rt-resizable-header-content,
                    .usuario-premium-table .ReactTable .rt-th .rt-th-content {
                        width: 100%;
                        text-align: center;
                        justify-content: center;
                    }

                    .usuario-premium-table .ReactTable .rt-td,
                    .usuario-premium-table .ReactTable .rt-th {
                        font-size: 12px;
                    }
                `}</style>

        <div className="usuario-premium-table">
          <PremiumTableShell summary={`${usuario.length} usuário(s) exibido(s)`} tableMinWidth={0}>
            <ReactTableGT2A
              data={usuario}
              columns={columns}
              className="-striped -highlight"
              defaultPageSize={15}
              showPagination
              filterable={true}
              onPageChange={this.handlePageChange}
              page={paginaAtual}
              style={{
                fontSize: '13px',
                width: '100%',
              }}
            />
          </PremiumTableShell>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.usuarioCad.list,
  paginaAtual: state.usuarioCad.paginaAtual,
  user: state.auth.user,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ showUpdate, remove, update, showNotificaoes, setPaginaAtual }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UsuarioList);
